import styled from 'styled-components';
import { FormControlLabel, Select } from '@material-ui/core';

// CONSTANTS
import { GRAY_SUIT, MAIN_BLACK, SANTAS_GRAY, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  .filters,
  &.filters {
    max-width: 325px;
    width: 100%;

    &__container {
      width: 100%;
      padding: 19px 30px 19px 50px;

      &--scrollable {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 530px;
      }

      &.collapsable__content {
        padding-top: 5px;
      }

      &.selected-filters {
        padding-bottom: 0;
      }

      ${breakpoints.down('sm')} {
        padding: 19px 3px;
      }
    }

    &__reset-filters {
      color: ${MAIN_BLACK};
      font-size: 14px;
      line-height: 14px;
      font-weight: 600;
      cursor: pointer;
    }

    &__search {
      .MuiInputBase-root {
        font-size: 1.8rem;
        font-weight: 400;
        padding: 9px 15px;

        input {
          padding: 5px 0 5px 7px;
          color: ${SANTAS_GRAY};
        }
      }

      &__icon {
        color: inherit;
        margin-top: 0;
        font-size: 2rem;
      }
    }
  }
`;

export const CollapseStyled = styled.div`
  .collapsable,
  &.collapsable {
    &__button {
      background-color: ${WHITE};
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-radius: 0;

      transition: all 0.4s;
      &:hover {
        color: ${p => p.theme.palette.primary.main};
        background-color: transparent;
      }
    }

    &__icon {
      font-size: 24px;
      color: ${GRAY_SUIT};
      &--open {
        transform: rotate(-180deg);
      }
    }
  }
`;

export const StyledContolLabel = styled(FormControlLabel)`
  .control-label,
  &.control-label {
    white-space: nowrap;

    .MuiFormControlLabel-label {
      font-size: 18px;
      line-height: 30px;
      font-weight: 400;
    }

    .MuiCheckbox-colorPrimary.Mui-checked + .MuiFormControlLabel-label {
      color: inherit;
    }

    &__checkbox {
      .icon-correct-symbol {
        font-size: 12px;

        &:before {
          width: 14px;
          height: 14px;
          border-width: 2px;
        }

        &.default {
          &:before {
            border-color: ${GRAY_SUIT};
          }
        }
      }
    }
  }
`;

export const SelectStyled = styled(Select)`
  .select,
  &.select {
    .MuiSelect-root {
      padding: 9px 40px 9px 12px;

      font-size: 17px;
      font-weight: 500;
      line-height: 30px;
      border-radius: 4px;

      &:focus {
        background-color: inherit;
      }
    }

    .MuiSelect-iconFilled {
      right: 12px;
    }

    .MuiPaper-root {
      margin-top: -4px;
    }

    .MuiList-root {
      max-height: 274px;
      padding: 4px 0;

      ${breakpoints.down('sm')} {
        max-height: 166px;
      }
    }

    &__option {
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      padding: 12px;
      white-space: normal;
      word-break: break-word;

      &.Mui-selected {
        font-weight: 500;
        background-color: transparent;
      }
    }
  }
`;

export const DrawerContent = styled.div`
  width: 100%;
  padding: 0 12px;
`;
